// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"795d3ea5","895":"611fa912"}[chunkId] + ".chunk.js";
};